/* eslint-disable */
import { useState, useEffect, useContext } from "react";
import AuthContext from "../../../../context/AuthProvider";
import axios from "axios";
import Cookies from "js-cookie";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import Toast from "../../../assetLibComponents/shared/Toast";

const ForgetPassword = (props) => {
  const authCtx = useContext(AuthContext);
  const FORGOT_URL = authCtx.forgotUrl;

  const [email, setEmail] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const [authToken, setAuthToken] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      Toast("Please enter the email", "E");
      return;
    }
    const officialDomains = [
        "gmail.com",
        "yahoo.com",
        "rediff.com",
        "yopmail.com",
        "outlook.com",
    ];
    const enteredDomain = email.split("@")[1];
    const isOfficial = officialDomains.includes(enteredDomain?.toLowerCase());
    const emailRegex = /^[A-Z0-9._%+-]+@([A-Z0-9.-]+\.)+[A-Z]{2,}$/i;
    const isEmailValid = emailRegex.test(email);
    if (isOfficial === true || isEmailValid === false) {
        Toast("Please enter the valid email", "E");
        return;
    }
    setButtonLoader(true);
    try {
      const response = await axios.post(FORGOT_URL, {
        email: email,
      });
      if (response?.data?.statusCode === "401") {
        Toast(response?.data?.message, "E");
        setButtonLoader(false);
      } else if (response?.data?.statusCode === "200") {
        navigate(`/checkemail?mailToken=${response?.data?.encrpt_url}&&ref=${email}`);    
        Cookies.set("fogetToken", response?.data?.encrpt_url)
        setButtonLoader(false);
      } else {
        Toast(response?.data?.message ? response?.data?.message : response?.data?.response, "E");
        setButtonLoader(false);
      }
      setEmail("");
    } catch (err) {
      setButtonLoader(false);
    }
  };

  useEffect(() => {
    setAuthToken(authCtx.auth);
  }, [setAuthToken, authCtx.auth, authToken]);

  let navigate = useNavigate();

  const title = props.title;
  useEffect(() => {
    document.title = `Get Started with Zoi | ${title}`;
    window.scrollTo(0, 0);

    // if (!localStorage.getItem("userData")) {
    //   navigate("/");
    // }
  }, [title, navigate]);

  return (
    <div title={props.title} className="mt-10">
    <div>
        <form className="space-y-6">
        <div>
            <label
            htmlFor="email"
            className="block text-sm font-medium leading-6 text-gray-900"
            >
            Enter email address
            </label>
            <div className="mt-2">
            <input
                type="email"
                placeholder="Email ID"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value)
                }}
                id="email"
                name="email"
                autoComplete="email"
                required
                className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
            />
            </div>
        </div>

        <div>
            <button
              onClick={handleSubmit}
              type="submit"
              className="flex h-[33px] w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
            >
                {buttonLoader ? <div className="login-dual-ring"></div> : 'Request reset link'}
            </button>
        </div>
          
        <p className="text-center text-sm text-gray-500">
            {/* Already Registered?{' '} */}
            <span onClick={()=>{navigate("/")}} className="cursor-pointer font-semibold leading-6 text-[var(--brand-primary)] hover:text-indigo-500">
              Back To Login
            </span>
        </p> 
        
        </form>
    </div>
    </div>
  );
};

export default ForgetPassword;
